import { render, staticRenderFns } from "./ViewAccount.vue?vue&type=template&id=236b11e2&scoped=true"
import script from "./ViewAccount.vue?vue&type=script&lang=js"
export * from "./ViewAccount.vue?vue&type=script&lang=js"
import style0 from "./ViewAccount.vue?vue&type=style&index=0&id=236b11e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "236b11e2",
  null
  
)

export default component.exports